import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/hooks';
import { availableCandidatesStoreKey } from './availableCandidates.const';

const getAvailableCandidatesData = createSelector(
  (state: RootState) => state[availableCandidatesStoreKey],
  (availableCandidates) => ({
    ...availableCandidates,
    data: availableCandidates.data.map((candidate) =>
      candidate.id in availableCandidates.marks
        ? { ...candidate, mark: availableCandidates.marks[candidate.id] }
        : candidate,
    ),
  }),
);

const getAvailableCandidatesCount = (state: RootState) =>
  state[availableCandidatesStoreKey].count;

export const availableCandidatesSelectors = {
  getAvailableCandidatesData,
  getAvailableCandidatesCount,
};
